import React, { useEffect, useState } from "react";

const ConfirmModal = ({
  open,
  setOpen,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  reasonLabel,
  reasonPlaceholder = "",
  reasonMaxLength = 100,
}) => {
  const [reason, setReason] = useState("");

  // Reset the reason to empty whenever the modal opens.
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black opacity-30"
        onClick={() => setOpen(false)}
      />
      <div className="relative min-w-[300px] rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-2 text-lg font-semibold">{title}</h2>
        <p className="mb-4 text-gray-700">{message}</p>
        {reasonLabel && (
          <div className="mb-4">
            <label className="mb-1 block text-sm text-gray-700">
              {reasonLabel}
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              maxLength={reasonMaxLength}
              placeholder={reasonPlaceholder}
              rows={3}
              className="w-full resize-none rounded border border-gray-300 p-2 text-sm"
            />
            <p className="mt-1 text-right text-xs text-gray-400">
              {reason.length}/{reasonMaxLength}
            </p>
          </div>
        )}
        <div className="flex justify-end gap-2">
          <button
            className="rounded bg-gray-200 px-4 py-2 text-gray-800"
            onClick={() => setOpen(false)}
          >
            {cancelText}
          </button>
          <button
            className="rounded bg-primary1 px-4 py-2 text-white"
            onClick={() => {
              setOpen(false);
              onConfirm(reason.trim());
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
